import React from 'react';

import {RandomWhale} from '@ergeon/core-components';

const ErrorFallbackScreen = () => {
  return (
    <div
      className="flex flex-col justify-center items-center h-screen overflow-hidden"
      data-testid="Error-fallbackScreen"
    >
      <RandomWhale />
    </div>
  );
};

export default ErrorFallbackScreen;
